
class MeasurementTypes {

  rangeType = 'range';
  discreteType = 'discrete';

}

export default new MeasurementTypes();
